<template>
  <div class="hit-html-html">
  <div class="hit-row">
    <div class="hit-col-md-4 hit-col-md-hit-offset-4 hit-text-center">

      <div class="hit-form-group hit-html-h3 hit-text-primary" style="margin-top: 0; margin-bottom: 30px;">

        <h1 class="hit-html-h1"><logo :id="1" style="font-size: 3em;"/></h1>

      </div>

      <ul class="hit-html-ul hit-html-nav hit-nav">
        <li class="hit-html-li hit-html-h4" v-for="(benefit) in $t('company.benefits')"><i class="hit-glyphicon hit-glyphicon-ok"></i> {{ benefit }}</li>
      </ul>

      <hr class="hit-html-hr" style="border-color: #55a79a; border-width: 4px;">

      <div class="hit-text-primary hit-html-h2 hit-form-group">
        {{ $t('company.mainBenefit') }}
      </div>

      <div class="hit-text-center hit-form-group" style="margin-top: 30px;">
        <router-link class="hit-btn hit-btn-primary hit-btn-xs" :to="{ name: 'sign_up', params: {lang: $store.getters.lang} }">{{ $t('message.signUp') }}</router-link>
        <router-link class="hit-btn hit-btn-default hit-btn-xs" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.signIn') }}</router-link>
     </div>

     <hit_stars :stars="stars" class="hit-text-primary"/>

    </div>

  </div>

    <div class="hit-row" style="background-color: #292b2c; margin-top: 80px; padding: 20px; color: white;">

        <div class="hit-col-md-4 hit-col-md-hit-offset-4">

          <h3 class="hit-html-h3 hit-text-primary">{{ $t("home.infoblock.title") }}</h3>

          <div class="hit-row" v-for="description in $t('home.infoblock.description')">

            <div class="hit-col-md-12">
              <hr class="hit-html-hr" />
            </div>

            <div class="hit-col-md-12">
              <i class="hit-glyphicon hit-glyphicon-ok hit-text-primary" style="font-size:2em; float:left; margin-right: 7px;"></i>
              <h4 class="hit-html-h4 hit-text-white hit-text-uppercase">
                {{ description[0] }}
              </h4>
            </div>

            <div class="hit-col-md-12">
              <p>{{ description[1] }}</p>
            </div>
          </div>

      </div>

    </div>

</div>

</template>

<script>

import logo from '@core/components/assets/logo.vue'

export default {
  name: 'home',
  components: {logo},
  data () {
    return {
      stars: this.animation_stars()
    }
  },

  methods: {
    animation_stars: function () {
      this.stars = this.get_stars()

      setTimeout(function () {
        this.animation_stars()
      }.bind(this), 300)
    },
    get_stars: function () {
      if (typeof this.stars === 'undefined' || this.stars == 5) { return 1 }

      return this.stars + 1

      // return (Math.floor(Math.random() * Math.floor(5)) +1 ) ;
    }
  }
}
</script>
